/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdresseDto
 */
export interface AdresseDto {
    /**
     * 
     * @type {number}
     * @memberof AdresseDto
     */
    idadresse?: number;
    /**
     * 
     * @type {number}
     * @memberof AdresseDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdresseDto
     */
    idcodePostal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    boite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    commune?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    pays?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdresseDto
     */
    idtypeAdresse?: number;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    codePostalText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDto
     */
    typeAdresse?: string | null;
}

/**
 * Check if a given object implements the AdresseDto interface.
 */
export function instanceOfAdresseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdresseDtoFromJSON(json: any): AdresseDto {
    return AdresseDtoFromJSONTyped(json, false);
}

export function AdresseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdresseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idadresse': !exists(json, 'idadresse') ? undefined : json['idadresse'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'idcodePostal': !exists(json, 'idcodePostal') ? undefined : json['idcodePostal'],
        'boite': !exists(json, 'boite') ? undefined : json['boite'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'commune': !exists(json, 'commune') ? undefined : json['commune'],
        'pays': !exists(json, 'pays') ? undefined : json['pays'],
        'idtypeAdresse': !exists(json, 'idtypeAdresse') ? undefined : json['idtypeAdresse'],
        'codePostalText': !exists(json, 'codePostalText') ? undefined : json['codePostalText'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'typeAdresse': !exists(json, 'typeAdresse') ? undefined : json['typeAdresse'],
    };
}

export function AdresseDtoToJSON(value?: AdresseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idadresse': value.idadresse,
        'idpersonne': value.idpersonne,
        'adresse': value.adresse,
        'idcodePostal': value.idcodePostal,
        'boite': value.boite,
        'localite': value.localite,
        'commune': value.commune,
        'pays': value.pays,
        'idtypeAdresse': value.idtypeAdresse,
        'codePostalText': value.codePostalText,
        'codePostal': value.codePostal,
        'typeAdresse': value.typeAdresse,
    };
}

